export default function (arr) {
  const headers = []

  arr.forEach(item => {
    headers.push(
      { title: `Нач. ост. ${item}` },
      { title: `Заправка ${item}` },
      { title: `Кон. ост. ${item}` },
      { title: `Расход ${item}` }
    )
  })

  return headers
}
